// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"035b76ac","455":"dd9d086e","484":"c8eb60b2","977":"dbb94a39"}[chunkId] + ".chunk.js";
};